import styles from "./ProductCell.module.less";
import { image as imageUtil, utils, productUtil, uploadEt } from "@/utils";
import { Image, ImageViewer } from 'antd-mobile'
import React, { useEffect, useState } from "react";
import localStorage from "@/utils/localStorage";

const { getLocalStorage } = localStorage
const { imgFormatter } = imageUtil;
const { to } = utils;

interface ProductCellProps {
  item: any;
  index: number;
  cellWidth: string;
}

interface Thumb {
  url: string;
  backupUrl?: string;
}

/* 
 * 货品详情
 */
const ProductCell: React.FC<ProductCellProps> = (props) => {
  const { item, index, cellWidth } = props;
  const [lastImgUrl, setLastImgUrl] = useState<string>("");
  const [thumbObj, setThumbObj] = useState<Thumb>({
    url: "",
  });

  // 显示画廊
  function handleImageViewer() {
    const { imageList, productId: product_id, productAttr8 } = item.cloudProduct;
    const ossRoot = getLocalStorage('ossRoot');
    const imgsUrl = (imageList && imageList.length) ? imageList : [];

    // 如果 productAttr8 有值，则说明图片是P过的，图片地址拼接’/poster‘显示P过的图
    const images = imgsUrl.map((src: string) => {
      return `${ossRoot}${src}${productAttr8 ? '/poster' : ''}`;
    });

    if (images.length) {
      uploadEt({ event_type: 10, products: [{ product_id }] }) // 埋点，商品分享网页 - 首页打开货品分类结果页次数

      ImageViewer.Multi.show({
        images,
        defaultIndex: 0,
      });
    }
  }

  // 初始化缩略图
  async function initThumb() {
    const { imageList } = item.cloudProduct;
    const imgUrl = (imageList && imageList[0]) || '';

    if (imgUrl === lastImgUrl) return;

    const [err, res] = await to(imgFormatter(imgUrl, 260));

    setLastImgUrl(imgUrl);
    setThumbObj({ url: err ? imgUrl : res });
  }

  useEffect(() => {
    initThumb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.item]);

  /* 
  * 货品详情
  */
  return (
    <div className={styles["product-item"]} key={index} onClick={() => handleImageViewer()}>
      <div className={styles["img-wrap"]} data-index={cellWidth} style={{ height: cellWidth }}>
        <Image
          src={thumbObj.url}
          fit="cover"
          height={cellWidth}
          className={styles["preview-img"]}
          lazy={true}
        />
      </div>
      <div className={styles["text-wrap"]}>
        <h3 className={styles["title"]}>
          <span className={productUtil.getRecommendClass(item.cloudProduct)}>
            {productUtil.getRecommendTag(item.cloudProduct)}
          </span>
          {item.cloudProduct.productName || ""}
          {item.cloudProduct.productNo ? `(${item.cloudProduct.productNo})` : null}
        </h3>
      </div>
    </div>
  );
};

export default ProductCell;
